import { Component } from '@verndale/core';
import { breakpoints } from '../helpers/variables';
import { debounce } from '../helpers';

class LogoCarousel extends Component {
  initialized = false;
  breakpoint = window.matchMedia(`(min-width: ${breakpoints.tablet}px)`);
  totalWidth = 0;
  animation?: number;

  constructor(el: HTMLElement) {
    super(el);

    this.initSlider();
  }

  setupDefaults() {
    this.dom = {
      logos: this.el.querySelectorAll('img')
    };
  }

  addListeners() {
    window.addEventListener(
      'resize',
      debounce(this.handleResize.bind(this), 300)
    );
    this.el.addEventListener('mouseenter', this.pauseSlider.bind(this));
    this.el.addEventListener('mouseleave', this.resumeSlider.bind(this));
  }

  initSlider() {
    const logos = this.dom.logos as NodeListOf<HTMLImageElement>;

    logos.forEach(logo => {
      this.totalWidth += logo.offsetWidth;
    });

    if (this.el.offsetWidth > this.totalWidth) return;

    this.el.classList.add('initialized');
    this.initialized = true;
    this.animation = window.requestAnimationFrame(this.animateLogos.bind(this));

    this.breakpoint.addEventListener('change', this.resizeSlider.bind(this));
  }

  pauseSlider() {
    this.animation && window.cancelAnimationFrame(this.animation);
  }

  resumeSlider() {
    if (!this.initialized) return;
    this.animation = window.requestAnimationFrame(this.animateLogos.bind(this));
  }

  stopSlider() {
    const logos = this.dom.logos as NodeListOf<HTMLImageElement>;
    this.el.classList.remove('initialized');
    this.initialized = false;

    logos.forEach(logo => {
      logo.setAttribute('style', '');
      this.animation && window.cancelAnimationFrame(this.animation);
    });
  }

  resizeSlider() {
    this.stopSlider();
    this.initSlider();
  }

  animateLogos() {
    const logos = this.dom.logos as NodeListOf<HTMLImageElement>;
    let position = 0;

    logos.forEach(logo => {
      let newPosition = logo.style.transform
        ? this.getTranslateX(logo)
        : position;

      position += logo.offsetWidth;

      if (newPosition < -logo.offsetWidth) {
        newPosition = this.totalWidth - logo.offsetWidth;
      }
      logo.style.transform = `translateX(${newPosition - 0.8}px)`;
    });

    this.animation = window.requestAnimationFrame(this.animateLogos.bind(this));
  }

  getTranslateX(logo: HTMLImageElement) {
    const style = window.getComputedStyle(logo);
    const matrix = new WebKitCSSMatrix(style.transform);
    return matrix.m41;
  }

  handleResize() {
    const logos = this.dom.logos as NodeListOf<HTMLImageElement>;
    let totalWidth = 0;

    logos.forEach(logo => {
      totalWidth += logo.offsetWidth;
    });

    if (
      this.el.offsetWidth > totalWidth &&
      this.el.classList.contains('initialized')
    ) {
      this.stopSlider();
    } else if (
      totalWidth > this.el.offsetWidth &&
      !this.el.classList.contains('initialized')
    ) {
      this.initSlider();
    }
  }
}

export default LogoCarousel;
